import React from "react";
import { Grid, TextField, Typography } from "@material-ui/core";
import AuthorizationWrapper from "../AuthorizationWrapper";

function MultiTextSetting(props) {
  const [value, setValue] = React.useState(props.setting.value);
  return (
    <AuthorizationWrapper
      permission={props.authenticationName}
      child={(write) => {
        return (
          <>
            <Grid container alignItems={"flex-start"} spacing={1}>
              <Grid item xs={4}>
                <Typography>{props.label}</Typography>
              </Grid>
              <Grid item xs={8}>
                <TextField
                  fullWidth
                  disabled={!write}
                  value={value}
                  multiline={true}
                  variant={"outlined"}
                  rows={5}
                  onChange={(e) => setValue(e.target.value)}
                  onBlur={() => {
                    props.onChange(value);
                  }}
                />
              </Grid>
            </Grid>
            {props.children}
          </>
        );
      }}
    />
  );
}

export default MultiTextSetting;
